export const urls = {
  DegreePrograms: {
    en: '/en/degree-programs',
    de: '/de/studiengaenge',
    fr: '/fr/programmes-detudes',
  },
  ContinuingEducations: {
    en: '/en/continuing-education',
    de: '/de/weiterbildung',
    fr: '/fr/formation-continue',
  },
};
